import PropTypes from 'prop-types';
import createClasses from '../../utils/classes';
import { HEX_COLOR_CHECK } from '../Sidebar/TrackKeys/TrackKey';

const buildDataAttributes = (attributes = {}) => {
  const value = {};
  Object.keys(attributes).forEach((name) => {
    value[`data-${name}`] = attributes[name];
  });
  return value;
};
const FALLBACK_BG_CLR = ' rgb(76 78 180)';
const getBG = (color) => {
  if (color) {
    if (HEX_COLOR_CHECK?.test(color)) {
      return color;
    }
    return FALLBACK_BG_CLR;
  }
  return FALLBACK_BG_CLR;
};

const Basic = ({
  title,
  style,
  classes,
  dataSet,
  isSubTrack,
  bg_color,
  isProject,
}) => {
  return (
    <div
      className={createClasses('', classes)}
      style={style}
      {...buildDataAttributes(dataSet)}
    >
      <div
        style={{
          backgroundColor:
            isSubTrack || isProject ? getBG(bg_color) : ' rgb(76 78 180)',
        }}
        className={`flex h-full items-center py-1.5 pl-2 `}
        aria-hidden="true"
      >
        <span
          className={` text-white  px-1 text-xs leading-[14px] ${
            isSubTrack
              ? ' font-SFProDisplay_Medium'
              : 'bg-white/25 font-SFProDisplay_Bold'
          }`}
        >
          {title}
        </span>
      </div>
    </div>
  );
};

Basic.propTypes = {
  start: PropTypes.instanceOf(Date).isRequired,
  end: PropTypes.instanceOf(Date).isRequired,
  style: PropTypes.shape({}),
  classes: PropTypes.arrayOf(PropTypes.string.isRequired),
  dataSet: PropTypes.shape({}),
  tooltip: PropTypes.string,
};

export default Basic;
